// The bot runs two lanes. VGPro's mode keys are kept as the wire values so the
// leaderboard API and its i18n labels stay where the client expects them.
export const LEADERBOARD_TYPES = [
  { value: "ranked5v5", icon: "/icons/ranked" },
  { value: "ranked", icon: "/icons/ranked" },
];

export const HEROES_TYPES = [
  { value: "pickRate", icon: "/icons/pickrate" },
  { value: "winRate", icon: "/icons/winrate" },
  { value: "banRate", icon: "/icons/banrate" },
];

// One community, one board.
export const REGIONS = ["all"];

export default {
  LEADERBOARD_TYPES,
  REGIONS,
  HEROES_TYPES,
};
